// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "li.sidenav-modulo-menuitem a[data-v-4a01c896]{font-weight:400;padding:0 37.5px 0 45px}", ""]);
// Exports
module.exports = exports;
